import { XIcon } from 'lucide-react'

import { TABLE_FILTER_BAR_LABELS } from '@/components/lemmala-design-system/table/labels'

/** Clears the filter's selection while keeping the filter chip on the bar. */
export const AgFilterClearButton = ({ onClear }: { onClear: () => void }) => (
  <button
    type='button'
    aria-label={TABLE_FILTER_BAR_LABELS.clearFilter}
    className='box-border flex size-8 items-center justify-center rounded-r bg-main-background-interactive-list-selected py-1.5 text-main-foreground-accent hover:bg-main-background-interactive-list-selectedHover focus:outline-none'
    onClick={onClear}
  >
    <XIcon className='size-4' />
  </button>
)
